import React, { useEffect, useState } from "react";
import axios from "axios";
import { FASTAPI_BASE_URL } from "./config";

const TestPublishPage = () => {
  const [tests, setTests] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Fetch unpublished tests
    const fetchTests = async () => {
      try {
        console.log("in TestPublishPage");
        const res = await axios.get(`${FASTAPI_BASE_URL}/tests/manage`);
        const unpublishedTests = res.data.filter(t => !t.is_published);
        setTests(unpublishedTests);
      } catch (err) {
        console.error("Error fetching tests", err);
      }
    };
    fetchTests();
  }, []);

  const publishTest = async (testId) => {
    try {
      await axios.patch(`${FASTAPI_BASE_URL}/tests/${testId}/publish?is_published=true`);
      setMessage(`Test ${testId} published.`);
      setTests(tests.filter(t => t.id !== testId));  // remove from UI
    } catch (err) {
      console.error("Failed to publish test", err);
      setMessage("Failed to publish test");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📢 Publish Tests</h2>
      {message && <p>{message}</p>}
      {tests.length === 0 ? (
        <p>No unpublished tests available.</p>
      ) : (
        <ul>
          {tests.map(test => (
            <li key={test.id} style={{ marginBottom: 10 }}>
              <strong>Test ID:</strong> {test.id} &nbsp;
              <strong>Title:</strong> {test.title || "(Untitled)"} &nbsp;
              <button onClick={() => publishTest(test.id)}>Publish</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TestPublishPage;
